<div
  class="container fb-container"
  [ngClass]="[isSidebarOpen ? '' : 'minimal']">
  <div class="d-flex justify-content-start">
    <button
      (click)="backToSettings()"
      class="text-decoration-none text-body-secondary btn btn-link p-0">
      < Back to ProForms
    </button>
  </div>
  <div class="card fb-card p-0 mt-3">
    <div class="fb-card-header">
      <h1 class="fs-3 mb-0 fw-light color-secondary">ProForms</h1>
      <h2 class="fs-1 fw-600 mb-0">Form Builder</h2>
    </div>
    <div class="p-3 p-lg-5 position-relative">
      <ng-container *ngIf="form; else loadingTemplate">
        <div class="sidebar" [class.open]="isSidebarOpen">
          <div class="sidebar-inner-wrapper">
            <button class="btn btn-toggle-sidebar" (click)="toggleSidebar()">
              <i *ngIf="isSidebarOpen" class="bi bi-chevron-right"></i>
              <i *ngIf="!isSidebarOpen" class="bi bi-gear"></i>
            </button>
            <div class="sidebar-body px-5 py-3 py-lg-5">
              <h3 class="fw-bold mb-1 fs-4">Settings</h3>
              <hr class="border border-tertiary border-1 mt-0" />

              @if(isE2L){
              <div class="form-group mt-2">
                <div
                  class="d-flex align-items-center justify-content-between mb-3">
                  <label class="form-label my-0 fw-600" for="lockForm"
                    >Lock Form</label
                  >
                  <button aria-label="Lock" class="form-switch btn-reset">
                    <input
                      class="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id="lockForm"
                      #lockForm
                      [checked]="form.is_locked === 1"
                      (change)="toggleLock($event)" />
                  </button>
                </div>
              </div>
              }

              <div class="position-relative">
                <div *ngIf="form.is_locked" class="sidebar-lock-overlay">
                  <div class="lock-message">
                    <i class="bi bi-lock-fill color-tertiary"></i>
                    <div>LOCKED</div>
                  </div>
                </div>
                <div
                  class="form-group mb-3"
                  *ngIf="
                    proformAnonymousEnabled && form.type === proFormType.SURVEY
                  ">
                  <div class="d-flex align-items-start justify-content-between">
                    <label class="fw-600" for="anonymity"
                      >Make Submissions Anonymous</label
                    >
                    <button
                      aria-label="anonymity-button"
                      class="form-switch btn-reset">
                      <input
                        class="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        id="anonymity"
                        [checked]="form.anonymity === ProFormAnonymity.REQUIRED"
                        (change)="toggleAnonymity($event)" />
                    </button>
                  </div>
                  <ng-container
                    *ngIf="form.anonymity === ProFormAnonymity.REQUIRED">
                    <div class="text-muted small mt-2">
                      <p>
                        When submissions are anonymous, filtering in reports is
                        limited. Filters that could identify users will not be
                        available.
                      </p>
                      <p>
                        Making a form anonymous prevents the form from being
                        shared to other districts
                      </p>
                    </div>
                  </ng-container>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label fw-bold" for="status">Status</label>
                  <ng-select
                    labelForId="status"
                    [items]="statuses"
                    bindLabel="value"
                    [clearable]="false"
                    [searchable]="false"
                    bindValue="key"
                    [(ngModel)]="form.status"
                    name="status"
                    (ngModelChange)="updateStatus()"></ng-select>
                </div>
                <div class="form-group mb-4" *ngIf="proformQuizzesEnabled">
                  <label class="form-label fw-bold" for="type">Type</label>
                  <ng-select
                    labelForId="type"
                    [items]="types"
                    bindLabel="value"
                    [clearable]="false"
                    [searchable]="false"
                    bindValue="key"
                    [(ngModel)]="form.type"
                    name="type"
                    placeholder="Select Type"
                    (ngModelChange)="updateType()"></ng-select>
                </div>
                <div
                  *ngIf="form.type === proFormType.QUIZ"
                  class="form-group mb-3">
                  <p class="fw-bold pt-2 mb-1">Quiz</p>
                  <div class="mb-4">
                    <div
                      class="d-flex align-items-center justify-content-between">
                      <label class="form-label fw-400 my-0" for="passing-grade"
                        >Passing Grade (0-100)</label
                      >
                      <input
                        [formControl]="passingGradeControl"
                        type="number"
                        class="form-control text-center"
                        id="passing-grade"
                        style="max-width: 80px"
                        aria-label="Passing Grade (0-100)"
                        [ngClass]="{
                          'is-invalid': passingGradeControl.errors
                        }" />
                    </div>
                    <div
                      *ngIf="passingGradeControl.errors"
                      class="text-danger small">
                      <div *ngIf="passingGradeControl.errors?.['required']">
                        Required for quizzes.
                      </div>
                      <div
                        *ngIf="passingGradeControl.errors?.['min'] || passingGradeControl.errors?.['max']">
                        Must be between 0-100.
                      </div>
                      <div
                        *ngIf="passingGradeControl.errors?.['notWholeNumber']">
                        Must be a whole number.
                      </div>
                    </div>
                  </div>
                  <p class="fw-bold mb-1">After submission,</p>
                  <div
                    class="d-flex align-items-center justify-content-between mb-3">
                    <label
                      class="form-label fw-normal my-0"
                      for="show-missed-questions"
                      >Show missed questions</label
                    >
                    <button
                      aria-label="Show missed questions"
                      class="form-switch btn-reset">
                      <input
                        class="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        id="show-missed-questions"
                        [checked]="form.show_missed === 1"
                        (change)="updateShowMissed($event)" />
                    </button>
                  </div>
                  <div
                    class="d-flex align-items-start justify-content-between mb-5">
                    <label
                      class="form-label fw-normal my-0"
                      [ngClass]="{
                        'text-muted': form.show_missed !== 1
                      }"
                      for="show-correct-answers"
                      >Show correct answers to missed questions</label
                    >
                    <button
                      [disabled]="form.show_missed !== 1"
                      aria-label="Show correct answers to missed questions"
                      class="form-switch btn-reset">
                      <input
                        [disabled]="form.show_missed !== 1"
                        [ngClass]="{
                          'cursor-pointer': form.show_missed === 1
                        }"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="show-correct-answers"
                        [checked]="form.show_answers === 1"
                        (change)="updateShowAnswers($event)" />
                    </button>
                  </div>
                </div>
              </div>

              @if(isE2L){
              <div
                class="form-group mt-2"
                [ngbTooltip]="
                  'Making submissions anonymous or setting status to Draft prevents the form from being shared to other districts'
                "
                [disableTooltip]="form.anonymity !== 'required' && !isDraft"
                [class.disabled-text]="
                  form.anonymity === 'required' || isDraft
                ">
                <p class="fw-bold mb-1">Sharing</p>
                <div
                  class="d-flex align-items-center justify-content-between mb-3">
                  <label
                    class="form-label fw-normal my-0"
                    for="shareFormAcrossDistricts"
                    >Share form across districts?</label
                  >
                  <button
                    aria-label="Share form across districts"
                    class="form-switch btn-reset">
                    <input
                      class="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      [disabled]="form.anonymity === 'required' || isDraft"
                      id="shareFormAcrossDistricts"
                      #shareFormAcrossDistricts
                      [checked]="form.is_shared === 1"
                      (change)="toggleSharing($event)" />
                  </button>
                </div>
              </div>
              <ng-container *ngIf="form.is_shared === 1">
                <div class="mb-3">
                  <label class="mb-2">
                    Share with these districts (default is share across all your
                    districts):
                  </label>
                  <app-district-select
                    #shareWithDistrictSelect
                    (selectedDistrictList)="handleShareDistricts($event)"
                    [defaultDistricts]="districtsSharedWith"
                    [isMulti]="true"></app-district-select>
                </div>
                <div class="mb-3">
                  <label class="mb-2">Exclude these districts:</label>
                  <app-district-select
                    #excludeFromDistrictSelect
                    (selectedDistrictList)="handleExcludeDistricts($event)"
                    [defaultDistricts]="districtsExcludedFrom"
                    [isMulti]="true"></app-district-select>
                </div>
              </ng-container>
              }
              <div
                class="form-group mt-5"
                *ngIf="
                  form.type !== proFormType.OBSERVATION &&
                  form.type !== proFormType.CALIBRATION
                ">
                <p class="fw-bold mb-1">URL</p>
                <div class="d-flex align-items-center">
                  <span class="url"> {{ sharingUrl }}</span>
                  <button
                    ngbTooltip="{{ copyTooltipMessage }}"
                    container="body"
                    #t="ngbTooltip"
                    (click)="copyUrl(t)"
                    class="btn btn-link color-tertiary ms-2 p-0">
                    <i class="bi bi-{{ copyIcon }}"></i>
                  </button>
                </div>
              </div>
              <ng-container *ngIf="isArchived">
                <button
                  class="btn btn-delete px-0 mt-5"
                  [autoClose]="'outside'"
                  [ngbPopover]="deletePopoverContent"
                  [popoverTitle]="'Delete Form'"
                  #popover="ngbPopover">
                  Delete
                </button>
                <ng-template #deletePopoverContent>
                  Permanently delete this form?
                  <div class="text-end mt-2">
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm px-3 m-1"
                      (click)="popover.close()">
                      No
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm px-3 m-1"
                      (click)="popover.close(); deleteForm()">
                      Yes
                    </button>
                  </div>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="isE2LOperator">
                <div class="form-group mt-5">
                  <p class="fw-bold mb-1">Instructional Insights Export</p>
                  <div
                    class="d-flex align-items-center justify-content-between">
                    <label
                      class="form-label fw-normal my-0"
                      for="instructional_insights_export">
                      Enable exporting instructional insights
                    </label>
                    <button
                      aria-label="Enable exporting instructional insights"
                      class="form-switch btn-reset">
                      <input
                        class="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        id="instructional_insights_export"
                        [checked]="form.instructional_insights_export === 1"
                        (change)="toggleInstructionalInsightsExport($event)" />
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="content-wrapper" [class.full-width]="!isSidebarOpen">
          <div class="content">
            <div #header class="sticky-header" [class.stuck]="isStuck">
              <div [ngClass]="{ 'container px-5 pt-2 pb-1': isStuck }">
                <div
                  class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
                  <input
                    *ngIf="!form.is_locked; else locked"
                    [(ngModel)]="form.title"
                    (ngModelChange)="onTitleChange($event)"
                    placeholder="Title"
                    type="text"
                    class="form-control title-input fw-800" />
                  <ng-template #locked>
                    <div
                      ngbTooltip="e2L has locked this form"
                      class="locked-title fw-800">
                      {{ form.title }}
                    </div>
                  </ng-template>

                  <button
                    type="button"
                    class="btn btn-primary btn-preview fw-bold"
                    (click)="previewModal.openModal()">
                    <i class="bi bi-eye me-2"></i> Preview
                  </button>
                </div>
              </div>
            </div>

            <div class="position-relative" style="padding: 40px 0">
              <div *ngIf="form.is_locked" class="main-lock-overlay">
                <div class="lock-message">
                  <i class="bi bi-lock-fill color-tertiary"></i>
                  <div>LOCKED</div>
                </div>
              </div>

              <div class="item-content" cdkDropListGroup>
                @if(form.sections) { @for(section of form.sections; track
                section?.id; let i = $index) {

                <!-- SECTION HEADER (only when 2+ sections) -->
                @if(form.sections.length > 1) {
                <app-proforms-admin-section
                  [section]="section"
                  [sectionIndex]="i + 1"
                  [allSections]="form.sections"
                  [formId]="formId"
                  [formType]="form.type"
                  (reorderRequested)="openReorderSectionsModal()"
                  (liveTitleChange)="liveSectionTitles[section.id] = $event" />
                }

                <!-- TOOLBAR: shown when this section is focused or when the section is empty -->
                @if(activeSectionId === section.id ||
                !section.questions?.length) {
                <div style="margin-bottom: 20px">
                  <app-proforms-add-form-item
                    [formId]="formId"
                    [sectionId]="section.id" />
                </div>
                }
                <div
                  cdkDropList
                  [cdkDropListData]="section.questions"
                  class="drop-questions"
                  [class.drop-questions--empty]="
                    !section.questions || section.questions.length === 0
                  "
                  (cdkDropListDropped)="
                    dropQuestion(section.questions, $event)
                  ">
                  <div
                    *ngFor="
                      let question of section.questions | sort : 'sort_order';
                      trackBy: trackByQuestionId
                    "
                    cdkDragLockAxis="y"
                    cdkDrag>
                    <div *cdkDragPreview class="drag-preview">
                      <app-safehtml [html]="question.question"></app-safehtml>
                    </div>
                    <div *cdkDragPlaceholder class="drag-placeholder">
                      <div class="box"></div>
                    </div>
                    <app-proforms-admin-question [question]="question" />
                  </div>
                </div>

                <!-- END-OF-SECTION MARKER (only when 2+ sections) -->
                @if(form.sections.length > 1) {
                <div class="section-end-marker">
                  END OF
                  {{
                    (liveSectionTitles[section.id] ?? section.title) ||
                      "UNTITLED SECTION" | uppercase
                  }}
                </div>
                } } }
              </div>

              <div
                class="card outro-card mt-5"
                [class.focused]="isEditingOutro">
                <div
                  class="card-header outro-card-header fs-6 d-flex justify-content-between">
                  Outro
                  <i
                    class="bi bi-info-circle-fill"
                    ngbTooltip="The outro is where you can write a confirmation message or next
                        steps. Respondents will see this message once they submit the
                        form."
                    containerClass="outro-card-tooltip"></i>
                </div>
                <div #outroBody>
                  <ng-container *ngIf="isEditingOutro; else previewOutro">
                    <div class="card-body outro-card-body">
                      <app-ck-editor
                        [version]="'full'"
                        [minHeight]="'150px'"
                        [initialData]="form.outro"
                        [channelId]="
                          'proforms_form_builder.' + form.id + '.outro'
                        "
                        (contentChange)="updateOutro($event)">
                      </app-ck-editor>
                    </div>
                  </ng-container>
                  <ng-template #previewOutro>
                    <div
                      (click)="showEditOutro($event)"
                      class="card-body outro-card-body position-relative pointer p-5">
                      <i class="bi bi-pencil color-tertiary edit-icon"></i>
                      <app-safehtml [html]="form.outro"></app-safehtml>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <app-proform-live-preview-modal #previewModal />
        <app-proforms-reorder-sections-modal
          #reorderSectionsModal
          [formId]="formId" />

        <app-modal
          #quizTypeConfirmModal
          (isDismissing)="cancelQuizTypeChange()"
          [modalConfig]="{
            titleText: 'Switch to Quiz?',
            headerClass: ['modal-header', 'bg-primary', 'text-white'],
            customFooter: true
          }">
          <button
            class="bg-transparent border-0"
            title="Close"
            aria-label="close"
            headerContent
            (click)="cancelQuizTypeChange()">
            <i class="bi bi-x-lg text-white"></i>
          </button>
          <p>Quiz forms do not support conditional sections.</p>
          <p class="mb-0">
            Any conditional section settings on this form will be removed. This
            cannot be undone.
          </p>
          <div footerContent>
            <div class="d-flex justify-content-between">
              <button
                type="button"
                class="btn"
                (click)="cancelQuizTypeChange()">
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-md btn-primary"
                (click)="confirmQuizTypeChange()">
                Switch to Quiz
              </button>
            </div>
          </div>
        </app-modal>
      </ng-container>
      <ng-template #loadingTemplate>
        <div
          class="w-100 position-relative"
          style="background-color: #fff; height: 500px">
          <app-loader></app-loader>
        </div>
      </ng-template>
    </div>
  </div>
</div>
